<div class="convocatorias-container">

  <div 
    class="conv-card"
    *ngFor="let t of tabs">

    <!-- HEADER -->
    <div 
      class="conv-header"
      [class.active]="tabActivo === t.nombre"
      (click)="tabActivo = tabActivo === t.nombre ? '' : t.nombre">

      <div class="icono">▶</div>

      <div class="titulo">
        {{t.nombre}}
      </div>

    </div>

    <!-- CONTENIDO -->
    <div 
      class="conv-body"
      *ngIf="tabActivo === t.nombre">

      <ul class="docs-list">
        <li *ngFor="let doc of t.archivos">
          <img src="assets/vinculacion/pdf.png">
          <a [href]="doc.url" target="_blank">
            {{doc.nombre}}
          </a>
        </li>
      </ul>

    </div>

  </div>

</div>